var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5623 15.1041C23.5623 13.4366 24.9157 12.0833 26.5832 12.0833V10.8749C26.5832 6.04159 25.3748 4.83325 20.5415 4.83325H8.45817C3.62484 4.83325 2.4165 6.04159 2.4165 10.8749V11.4791C4.084 11.4791 5.43734 12.8324 5.43734 14.4999C5.43734 16.1674 4.084 17.5208 2.4165 17.5208V18.1249C2.4165 22.9583 3.62484 24.1666 8.45817 24.1666H20.5415C25.3748 24.1666 26.5832 22.9583 26.5832 18.1249C24.9157 18.1249 23.5623 16.7716 23.5623 15.1041Z",
    stroke: "#7539FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 4.83325L12.0835 24.1666",
    stroke: "#7539FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.c7df85904a037effa9f398f626a3514e.svg";
export { ForwardRef as ReactComponent };